import { render, staticRenderFns } from "./PrepExamDefinationsSelectbox.vue?vue&type=template&id=e1e1c712"
import script from "./PrepExamDefinationsSelectbox.vue?vue&type=script&lang=js"
export * from "./PrepExamDefinationsSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports